/* eslint-disable no-tabs */
/* eslint-disable no-mixed-spaces-and-tabs */
import {
  mdiViewDashboard,
  mdiCog,
  mdiCogs,
  mdiTownHall,
  mdiDatabase,
  mdiFinance,
  mdiTextBoxMultipleOutline,
  mdiEmailFast,
  mdiEmail,
  mdiNotebookMultiple,
  mdiCubeSend,
  mdiPackageVariant,
  mdiCalendarMonth,
  mdiAccountCash,
  mdiCash,
  mdiCashMultiple,
  mdiCurrencyUsd,
  mdiCalculatorVariant,
  mdiNewspaperVariant,
  mdiNewspaperVariantOutline,
  mdiFileChartOutline,
  mdiRepeat,
  mdiProgressUpload,
  mdiEmailEditOutline,
  mdiNotebookEditOutline,
  mdiBroadcast,
  mdiPalette,
  mdiAccountCircle,
  mdiAccountGroup
} from '@mdi/js'

export default [
    {
      to: '/',
      icon: mdiViewDashboard,
      label: 'finance.sidebar.dashboard'
    },
    {
      label: 'finance.sidebar.master.master',
      subLabel: 'Submenus Master',
      icon: mdiDatabase,
      menu: [
        {
          to: '/financial-year',
          label: 'finance.sidebar.master.finYear',
          icon: mdiCalendarMonth
        },
        {
          to: '/coa',
          label: 'finance.sidebar.master.coa',
          icon: mdiFinance,
          updateMark: true
        },
        {
          to: '/templateemail',
          label: 'finance.sidebar.master.emailTemplate',
          icon: mdiEmail
        },
        {
          to: '/typejournal',
          label: 'finance.sidebar.master.journalType',
          icon: mdiNotebookMultiple
        },
        {
          to: '/bank',
          label: 'Bank',
          icon: mdiCashMultiple
        },
        {
			    to: '/vacode',
          label: 'finance.sidebar.master.vaCode',
          icon: mdiNotebookEditOutline
        },
        {
          to: '/vastudent',
          label: 'finance.sidebar.master.vaStudent',
          icon: mdiNotebookEditOutline
        },
        {
          label: 'finance.sidebar.master.transaction.transaction',
          subLabel: 'finance.sidebar.master.transaction.transaction',
          icon: mdiCashMultiple,
          menu: [
            {
              to: '/transaction-type',
              label: 'finance.sidebar.master.transaction.transType',
              icon: mdiCashMultiple
            },
            {
              to: '/transaction-group',
              label: 'finance.sidebar.master.transaction.transGroup',
              icon: mdiCashMultiple
            }
          ]
        },
        {
          to: '/credit-status',
          label: 'finance.sidebar.master.creditStatus',
          // label: 'Credit Status',
          icon: mdiPalette
        }
      ]
	  },
    {
      label: 'finance.sidebar.student.student',
      // label: 'Student',
      subLabel: 'Submenus Student',
      icon: mdiAccountCircle,
      menu: [
        {
          to: '/students',
          label: 'finance.sidebar.student.student',
          icon: mdiAccountGroup
        }
      ]
    },
	  {
      label: 'finance.sidebar.incomes.incomes',
      subLabel: 'Submenus Incomes',
      icon: mdiAccountCash,
      menu: [
        {
          to: '/typesofincome',
				  label: 'finance.sidebar.incomes.incType',
				  icon: mdiCash
        },
        {
          to: '/incomegroup',
				  label: 'finance.sidebar.incomes.groupType',
				  icon: mdiCash
        },
        {
          to: '/income',
				  label: 'finance.sidebar.incomes.income',
				  icon: mdiCashMultiple
        },
        {
          to: '/uploadincome',
          label: 'finance.sidebar.incomes.upIncome',
          icon: mdiProgressUpload
        },
        {
          to: '/generatepenalty',
          label: 'finance.sidebar.incomes.genPenalty',
          icon: mdiCalculatorVariant
        },
        {
          to: '/generateva-new',
          label: 'finance.sidebar.incomes.genVa',
          icon: mdiRepeat
        },
        {
          to: '/uploadva',
          label: 'finance.sidebar.incomes.uploadVa',
          icon: mdiProgressUpload
        },
        {
          to: '/invoicetransaction',
          label: 'sidebarFin.invoicetransaction',
          icon: mdiTextBoxMultipleOutline
        },
        {
          to: '/paymenttransaction',
          label: 'sidebarFin.paymenttransaction',
          icon: mdiCashMultiple
        },
        {
          to: '/sendemail',
          label: 'sidebarFin.sendEmail',
          icon: mdiEmailFast
        }
      ]
	  },
	  {
      label: 'finance.sidebar.journal.journal',
      subLabel: 'Submenus Journal',
      icon: mdiNewspaperVariant,
      menu: [
        {
          to: '/journal',
				  label: 'finance.sidebar.journal.generalJournal',
				  icon: mdiNewspaperVariantOutline
        },
        {
          to: '/reversingdate',
				  label: 'finance.sidebar.journal.reversingdate',
				  icon: mdiNewspaperVariantOutline
        }
      ]
    },
    {
      label: 'finance.sidebar.email.email',
      subLabel: 'Submenus Email / Whatsapp',
      icon: mdiEmail,
      menu: [
        {
          to: '/sent',
      		label: 'finance.sidebar.email.sentBox',
      		icon: mdiCubeSend
		    },
		    {
          to: '/outbox',
      		label: 'finance.sidebar.email.outBox',
      		icon: mdiPackageVariant
		    }
      ]
	  },
    {
	  label: 'finance.sidebar.settings.settings',
	  subLabel: 'Submenus Setting',
	  icon: mdiCog,
	  menu: [
        {
          to: '/settingodoo',
          label: 'finance.sidebar.settings.setOdoo',
          icon: mdiCogs
        },
        {
			    to: '/settingemail',
          label: 'finance.sidebar.settings.setEmail',
          icon: mdiEmailEditOutline
        },
        {
          to: '/settingschool',
          label: 'finance.sidebar.settings.setSchool',
          icon: mdiTownHall
        },
        {
          to: '/setting-publish',
          label: 'finance.sidebar.settings.setPublish',
          icon: mdiBroadcast
        },
        {
			    to: '/general',
          label: 'finance.sidebar.settings.general',
          icon: mdiNotebookEditOutline
        }
		  ]
    },
	  {
      label: 'finance.sidebar.report.report',
      subLabel: 'Submenus Report',
      icon: mdiFileChartOutline,
      menu: [
        {
          to: '/aroutstanding',
          label: 'finance.sidebar.incomes.arOutstanding',
          icon: mdiFinance
        },
        {
          to: '/araging',
          label: 'finance.sidebar.incomes.arAging',
          icon: mdiFinance
        },
        {
          to: '/arsummary',
				  label: 'finance.sidebar.report.outArSummary',
				  icon: mdiFinance
        },
        {
          to: '/financial-report',
				  label: 'finance.sidebar.report.financialReport',
				  icon: mdiCashMultiple
        },
        {
          label: 'finance.sidebar.report.paySummart',
          subLabel: 'Transaction',
          icon: mdiCurrencyUsd,
          menu: [
            {
              to: '/paymentsummaryclass',
              label: 'finance.sidebar.report.byDeptClass',
              icon: mdiCurrencyUsd
            },
            {
              to: '/paymentsummarytype',
              label: 'finance.sidebar.report.byJournal',
              icon: mdiCurrencyUsd
            }
          ]
        },
        {
          to: '/paymentreportimport',
				  label: 'finance.sidebar.report.uploadPaymentReport',
				  // label: 'Upload Payment Report',
				  icon: mdiCashMultiple
        },
        {
          to: '/reportcandidatepayment',
				  label: 'finance.sidebar.report.reportCandidatePayment',
				  // label: 'Report Candidate Payment',
				  icon: mdiCashMultiple
        },
        {
          to: '/reportcreditstatus',
				  label: 'finance.sidebar.report.reportCreditStatus',
				  // label: 'Report Credit Status',
				  icon: mdiCashMultiple
        }
      ]
    }
]
